import React from "react";
import {
  FaBookOpen,
  FaChalkboardTeacher,
  FaSmile,
  FaUsers,
  FaProjectDiagram,
  FaChild,
  FaGlobe,
  FaShapes,
  FaHandsHelping,
  FaHeart,
  FaShieldAlt,
  FaUniversalAccess,
  FaStar,
} from "react-icons/fa";
import "./PrimarySchool.css";

const PrimarySchool = () => {
  return (
    <div className="primary-school-page">
    
      {/* Section 1 */}
      <section className="primary-section">
        <h1>
          <FaBookOpen className="icon" /> Primary Education: How Academic Group
          of Schools(AGS) Nurtures Young Minds Through Play &
          Purpose?
        </h1>
        <p>
          At Academich Group of Schools, we integrate STEM (Science, Technology,
          Engineering, and Mathematics) into our primary school curriculum to
          develop critical thinking, creativity, and problem-solving skills.
          Through hands-on activities and teamwork, students are encouraged to
          explore, collaborate, and think innovatively. STEM learning at the
          primary level fosters skills that students will carry throughout their
          lives.
        </p>
      </section>

      {/* Section 2 */}
      <section className="primary-section">
        <h2>
          <FaChalkboardTeacher className="icon" /> Education Methodologies at
          AGS
        </h2>
        <p>
          AGS utilizes a range of progressive and child-centred teaching
          methodologies to ensure an engaging and effective learning experience
          for young children.
        </p>
      </section>

      {/* Section 3 */}
      <section className="primary-section">
        <h2>
          <FaSmile className="icon" /> S.M.I.L.E.S
        </h2>
        <p>
          The S.M.I.L.E.S approach integrates Sensory, Motor, Intellectual,
          Linguistic, Emotional, and Social development into the curriculum,
          ensuring that students learn in ways that match their natural growth
          stages.
        </p>
      </section>

      {/* Section 4 */}
      <section className="primary-section">
        <h2>
          <FaHeart className="icon" /> PSHE (Personal, Social & Health
          Education)
        </h2>
        <p>
          The PSHE curriculum focuses on holistic child development, including
          personal health, social skills, and emotional well-being. AGS
          incorporates this across all levels, ensuring children grow into
          well-rounded individuals.
        </p>
      </section>

      {/* Section 5 */}
      <section className="primary-section">
        <h2>
          <FaProjectDiagram className="icon" /> PBL (Project-Based Learning)
        </h2>
        <p>
          AGS emphasizes Project-Based Learning, allowing students to apply
          theoretical knowledge to real-world situations. This not only makes
          learning more interactive but also encourages critical thinking and
          problem-solving.
        </p>
      </section>

      {/* Section 6 */}
      <section className="primary-section">
        <h2>
          <FaChild className="icon" /> Early Years Programme: The Building
          Blocks of Education
        </h2>
        <p>
          The Early Years Programme at AGS is designed to introduce young
          learners to the world of education in a playful and supportive
          environment. The focus is on a well-rounded approach to learning,
          catering to a child’s physical, emotional, and intellectual needs.
        </p>
      </section>

      {/* Section 7 */}
      <section className="primary-section">
        <h2>
          <FaGlobe className="icon" /> Thematic Inquiry-based Learning (Knowledge of the World)
        </h2>
        <p>
          Thematic Inquiry-based Learning at AGS organizes the curriculum around
          broad themes, enabling children to explore different subjects in an
          integrated and engaging manner. This approach fosters active
          engagement and nurtures curiosity.
        </p>
      </section>

      {/* Section 8 */}
      <section className="primary-section">
        <h2>
          <FaShapes className="icon" /> Concrete, Pictorial & Abstract Learning
        </h2>
        <p>
          AGS employs a Concrete-Pictorial-Abstract learning approach, starting
          with hands-on, concrete experiences, moving to pictorial
          representations, and finally advancing to abstract concepts, helping
          children build a deeper understanding of complex ideas.
        </p>
      </section>

      {/* Section 9 */}
      <section className="primary-section">
        <h2>
          <FaHandsHelping className="icon" /> Parental Involvement
        </h2>
        <p>
          AGS believes that parental involvement is essential in early childhood
          education. Parents are the first educators, and AGS actively
          encourages collaboration between parents and teachers.
        </p>
      </section>

      {/* Section 10 */}
      <section className="primary-section">
        <h2>
          <FaUsers className="icon" /> Child-centred Approach
        </h2>
        <p>
          We promote individualized instruction, adapting teaching strategies
          and activities to meet the needs and learning styles of each child,
          acknowledging that every child is unique with their own strengths and
          needs.
        </p>
      </section>

      {/* Section 11 */}
      <section className="primary-section">
        <h2>
          <FaHeart className="icon" /> Personal, Social, Health & Emotional
          Education (P.S.H.E)
        </h2>
        <p>
          Focuses on fostering children's personal, social and health
          development. It includes promoting self-awareness, emotional
          regulation, social skills, empathy and physical well-being.
        </p>
      </section>

      {/* Section 12 */}
      <section className="primary-section">
        <h2>
          <FaShieldAlt className="icon" /> Safe and Supportive Environment
        </h2>
        <p>
          A safe and supportive environment is essential for children's
          well-being and learning. It involves clear expectations, positive
          classroom culture, and inclusive interactions.
        </p>
      </section>

      {/* Section 13 */}
      <section className="primary-section">
        <h2>
          <FaUniversalAccess className="icon" /> Inclusive Education
        </h2>
        <p>
          Our curricula promote inclusive practices that ensure all children,
          regardless of their abilities, backgrounds, or differences, have equal
          access to education.
        </p>
      </section>

      {/* Section 14 */}
      <section className="primary-section">
        <h2>
          <FaChild className="icon" /> Primary School Grade 1-2: Nurturing Young
          Minds
        </h2>
        <p>
          The Early Primary Programmes for Grades 1 and 2 at AGS are thoughtfully
          designed to meet the developmental needs of young children. The aim is
          to help children develop into critical thinkers and lifelong learners.
        </p>
      </section>

      {/* Section 15 */}
      <section className="primary-section">
        <h2>
          <FaStar className="icon" /> The Path to Lifelong Learning!
        </h2>
        <p>
          At Academich Group of Schools (AGS), primary education is not just about
          knowledge acquisition—it’s about nurturing curiosity, creativity, and
          critical thinking. By emphasizing STEM, skills, and service, AGS
          provides a well-rounded education.
        </p>
      </section>
    </div>
  );
};

export default PrimarySchool;
